// Charte graphique Biz360
export const COLORS = {
  principale: '#E8A87C',  // Orange corail
  secondaire: '#FDFCFF',  // Violet très clair (fond encarts)
  accent: '#897FCB',      // Violet foncé
  text: '#210875',        // Bleu foncé
  bg: '#FDFCFF',          // Violet très clair pour fond des encarts
  success: '#059669',     // Vert émeraude
  warning: '#D97706',     // Orange foncé
  error: '#B91C1C',       // Rouge bordeaux
};

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Règles TVA par nature de dépense (pour assujettis)
export const TVA_DEDUCTIBLE_PAR_NATURE = {
  // ✅ DÉDUCTIBLE 100% — taux 20%
  "Matières premières":        { taux: 20, deductible: 100, message: null },
  "Achat de marchandises":     { taux: 20, deductible: 100, message: null },
  "Fournitures bureau":        { taux: 20, deductible: 100, message: null },
  "Matériel informatique":     { taux: 20, deductible: 100, message: null },
  "Abonnement logiciel":       { taux: 20, deductible: 100, message: null },
  "Abonnement internet":       { taux: 20, deductible: 100, message: null },
  "Abonnement téléphone":      { taux: 20, deductible: 100, message: null },
  "Frais de communication":    { taux: 20, deductible: 100, message: null },
  "Matériel professionnel":    { taux: 20, deductible: 100, message: null },
  "Véhicule utilitaire":       { taux: 20, deductible: 100, message: null },
  "Électricité véhicule":      { taux: 20, deductible: 100, message: null },

  // ✅ DÉDUCTIBLE 100% — taux réduit
  "Repas d'affaires":          { taux: 10, deductible: 100, message: "Taux TVA restauration 10%. Justificatif obligatoire." },

  // ⚠️ DÉDUCTIBLE PARTIEL
  "Carburant essence":         { taux: 20, deductible: 80, message: "TVA récupérable à 80% pour véhicule de tourisme. Passez à 100% si véhicule utilitaire." },
  "Carburant gazole":          { taux: 20, deductible: 80, message: "TVA récupérable à 80% pour véhicule de tourisme. Passez à 100% si véhicule utilitaire." },
  "Frais de déplacement":      { taux: 20, deductible: 80, message: "TVA récupérable à 80% pour carburant véhicule de tourisme." },
  "Cadeaux clients":           { taux: 20, deductible: 100, message: "TVA non récupérable si valeur > 73€ TTC par bénéficiaire et par an. Ajustez si nécessaire." },

  // ❌ TVA EXISTANTE MAIS NON DÉDUCTIBLE
  "Véhicule de tourisme":      { taux: 20, deductible: 0, message: "TVA jamais récupérable sur véhicule de tourisme (CGI art. 206)." },
  "Hébergement (hôtel)":       { taux: 10, deductible: 0, message: "TVA non déductible pour le dirigeant. Déductible uniquement si réglé pour un client/tiers." },

  // ❌ PAS DE TVA (taux 0%)
  "Assurance pro":             { taux: 0, deductible: 0, message: "Les primes d'assurance sont exonérées de TVA." },
  "Frais bancaires":           { taux: 0, deductible: 0, message: "Les services bancaires sont exonérés de TVA." },
  "Loyer local":               { taux: 0, deductible: 0, message: "TVA applicable uniquement si votre bailleur a opté pour la TVA. Ajustez si c'est le cas." },
  "Cotisation Urssaf":         { taux: 0, deductible: 0, message: "Pas de TVA sur les cotisations sociales." },
  "CFE":                       { taux: 0, deductible: 0, message: "Pas de TVA sur la CFE." },
  "Formation professionnelle": { taux: 0, deductible: 0, message: "Les formations sont exonérées de TVA (si organisme certifié Qualiopi)." },

  // 🔄 Fallback : Achats divers (catégorie générique, TVA 20% / 100% par défaut, à ajuster si besoin)
  "Achats divers":             { taux: 20, deductible: 100, message: "Catégorie générique. Si tu peux préciser la nature exacte (logiciel, fourniture, etc.), tu auras un suivi TVA plus juste." },
};
